import { Component, Input, OnInit } from '@angular/core';
import { Dimensions } from '../dimensions.model';
import { IconsService } from '../icon-service.service';

@Component({
  selector: 'modal-close',
  templateUrl: './close.component.html',
  styleUrls: ['./close.component.scss'],
  standalone: false,
})
export class CloseComponent implements OnInit {
  @Input() className = '';
  @Input() size = '30';
  @Input() classColor!: string;

  width = 30;
  height = 30;

  constructor(private iconService: IconsService) {}

  ngOnInit(): void {
    const dimensions: Dimensions = this.iconService.setDimensions({
      size: this.size,
      width: this.width,
      height: this.height,
    });
    this.width = dimensions.width;
    this.height = dimensions.height;
  }
}
